interface MarketDataSectionProps {
  headerLine1: string
  headerLine2: string
  titleLine1: string
  titleLine2: string
  body: string
  emphasis: string
  chartUrl: string
  chartUrlMobile: string
  chartAlt: string
}

export function MarketDataSection({
  headerLine1,
  headerLine2,
  titleLine1,
  titleLine2,
  body,
  emphasis,
  chartUrl,
  chartUrlMobile,
  chartAlt,
}: MarketDataSectionProps) {
  return (
    <section id="market-data" data-marketing-section="" className="w-full bg-qb-bg py-14 lg:py-24 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 flex flex-col gap-10 lg:gap-20 items-center">
        {/* Section header — Figma mobile (node 150:17015) is centered; desktop also centered */}
        <div className="flex flex-col gap-1 lg:gap-2.5 items-center text-center font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
          <p className="text-qb-text-high whitespace-pre-line lg:whitespace-normal">
            {headerLine1}
          </p>
          <p className="text-qb-primary">{headerLine2}</p>
        </div>

        {/* Contents */}
        <div data-testid="text-image-split" className="w-full flex flex-col lg:flex-row gap-14 lg:gap-0 items-center lg:justify-between">
          {/* Text block — Figma mobile (node 150:17019) centers all text; desktop reverts to left-aligned column */}
          <div className="flex flex-col gap-6 lg:gap-10 items-center text-center lg:items-start lg:text-left">
            <div className="flex flex-col gap-1 font-bold text-[24px] lg:text-[32px] leading-[1.4]">
              <p className="text-[#1e1e1e]">{titleLine1}</p>
              <p className="text-qb-primary">{titleLine2}</p>
            </div>
            <div className="flex flex-col gap-6">
              <p className="font-normal text-qb-text-mid text-[18px] lg:text-[20px] leading-[1.5] whitespace-pre-line">
                {body}
              </p>
              <p className="font-bold text-qb-text-high text-[20px] lg:text-[24px] leading-[1.5] lg:leading-[1.4] whitespace-pre-line">
                {emphasis}
              </p>
            </div>
          </div>

          {/* Chart */}
          <picture>
            <source media="(min-width: 1024px)" srcSet={chartUrl} />
            <img
              src={chartUrlMobile}
              alt={chartAlt}
              className="w-[312px] h-[200px] lg:w-[560px] lg:h-[362px] object-contain"
            />
          </picture>
        </div>
      </div>
    </section>
  )
}
